module.exports = require('./helpers/bundle-url').getBundleURL('hg7Qi') + "Camera-Potential-Doodle.8f7a62d3.mp4";